module.exports = new __parcel__URL__("logo.6f29349e.webp").toString();